<template>
  <div class="nav" @click="close" :class="{ open: is_open }">
    <div class="nav__container">
      <ul class="nav__list">
        <li class="nav__list-item" v-for="link in nav_links" :key="link.to">
          <a
            :href="'#' + link.to"
            class="nav__list-link link"
            @click="scrollTo(link.to)"
            >{{ link.name }}</a
          >
        </li>
      </ul>
      <a
        v-if="device_platform === 'mobile'"
        :href="'tel:+' + CONSTANTS.phone_raw"
        class="nav__phone call_phone_1"
      >
        {{ CONSTANTS.phone }}
      </a>
      <img
        class="nav__close"
        v-if="device_platform === 'mobile'"
        src="../images/utils/close.svg"
        alt="X"
      />
    </div>
  </div>
</template>

<script>
import Mixin from "../common/mixin";
import smoothScrollTo from "../common/smoothScrollTo";
import $ from "jquery";

export default {
  name: "header-nav",
  props: ["is_open"],
  mixins: [Mixin],
  data() {
    return {
      nav_links: [
        {
          to: "directions",
          name: "Направления",
        },
        {
          to: "promotions",
          name: "Акции",
        },
        {
          to: "season_tickets",
          name: "Абонементы",
        },
        {
          to: "contacts",
          name: "Контакты",
        },
      ],
    };
  },
  methods: {
    scrollTo(where) {
      let offset = this.device_platform === "desktop" ? 110 : 160;
      smoothScrollTo($("#" + where).offset().top - offset);
    },
    handleCall() {
      this.$emit("getCall");
    },
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/constants.scss";

.nav {
  flex-grow: 0.4;
  &__container {
  }

  &__list {
    display: flex;
    align-items: center;
    justify-content: space-between;
    list-style: none;
  }

  &__list-item {
  }

  &__list-link {
    font-size: calcFontSize(14, 18, 800, 1920);
  }
}

@media (max-width: 640px) {
  .nav {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.8);
    padding: 0;
    z-index: 150;
    opacity: 0;
    pointer-events: none;

    &__container {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      transition: $transition;
      transform: translateY(-100%);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }

    &__list {
      flex-direction: column;
    }

    &__list-link {
      display: block;
      font-size: 24px;
      padding: 15px 0;
    }

    &__phone {
      font-size: 24px;
      padding: 15px 0;
    }

    &__close {
      width: 30px;
      height: 30px;
      margin-top: 20px;
    }

    &.open {
      z-index: 300;
      opacity: 1;
      pointer-events: all;

      .nav__container {
        transform: translateY(0);
      }
    }
  }
}
</style>